import { create } from 'zustand';

export interface LayoutState {
  spinnerOpen: boolean;
  menuOpen: boolean;
  showSpinner: () => void;
  hideSpinner: () => void;
  openMenu: () => void;
  closeMenu: () => void;
  toggleMenu: () => void;
}

export const createLayoutStore = () =>
  create<LayoutState>((set) => ({
    spinnerOpen: false,
    menuOpen: false,
    showSpinner: () => set({ spinnerOpen: true }),
    hideSpinner: () => set({ spinnerOpen: false }),
    openMenu: () => set({ menuOpen: true }),
    closeMenu: () => set({ menuOpen: false }),
    toggleMenu: () => set((state) => ({ menuOpen: !state.menuOpen }))
  }));

export type LayoutStore = ReturnType<typeof createLayoutStore>;

export const createLayoutActionHooks = (useLayoutStore: LayoutStore) => ({
  useLayoutActions: () => ({
    showSpinner: useLayoutStore((state) => state.showSpinner),
    hideSpinner: useLayoutStore((state) => state.hideSpinner),
    openMenu: useLayoutStore((state) => state.openMenu),
    closeMenu: useLayoutStore((state) => state.closeMenu),
    toggleMenu: useLayoutStore((state) => state.toggleMenu)
  }),
  useSpinnerActions: () => ({
    showSpinner: useLayoutStore((state) => state.showSpinner),
    hideSpinner: useLayoutStore((state) => state.hideSpinner)
  })
});

export const createGlobalSpinnerHelpers = (useLayoutStore: LayoutStore) => ({
  showGlobalSpinner: () => useLayoutStore.getState().showSpinner(),
  hideGlobalSpinner: () => useLayoutStore.getState().hideSpinner()
});
